import type { ViewMode } from ".";

export const VIEW_PATH: Record<ViewMode, string> = {
  today: "/today",
  calendar: "/calendar",
  tasks: "/tasks",
  habits: "/habits",
  agenda: "/agenda",
  stats: "/stats",
  "free-slots": "/free-slots",
  weekly: "/weekly",
  schedule: "/schedule",
  eisenhower: "/eisenhower",
  journal: "/journal",
  kanban: "/kanban",
};

const PATH_VIEW: Record<string, ViewMode> = Object.fromEntries(
  Object.entries(VIEW_PATH).map(([k, v]) => [v, k as ViewMode]),
);

export function pathToViewMode(path: string): ViewMode {
  return PATH_VIEW[path] ?? "today";
}

export function isKnownAppRoute(path: string): boolean {
  return path === "/" || path === "/calendar/fullscreen" || path === "/calendar/fullscreen-app" || path in PATH_VIEW;
}
